import { AUTH_URL } from '@/constants/constants';

export const getAuthUrlWithRedirect = (redirectUrl?: string) =>
    `${AUTH_URL}${redirectUrl ? `?redirect=${redirectUrl}` : ''}`;
